import { PERSON } from "@/components/InmateDetails/Personal";
export const DOMAIN = "dev-e578z005mx6gvs5k.us.auth0.com";
export const CLIENT_ID = "1E6cqNqtSDPL5QvAwk1TXgVIBPbT2dbR";

export const disabledEnabled = [
  {
    label: "Enabled",
    value: "true",
  },
  {
    label: "Disabled",
    value: "false",
  },
];

export const bookingsPageValidations = [
  {
    paramContext: "bio:height",
    required: true,
    paramName: "RegularExpression",
    paramValue:
      "(100|[1-8][0-9]{2}|900)||The value for height must be a number between 100 to 900.",
  },
  {
    paramContext: "bio:weight",
    required: true,
    paramName: "RegularExpression",
    paramValue:
      "(50|[5-9][0-9]|[1-4][0-9]{2}|500)||The value for weight must be a number between 50 to 500.",
  },
  {
    paramContext: "bio:hair",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:eyes",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:glasses",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:hairLength",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:facialHair",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:complexion",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:ethnicity",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:build",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:hairStyle",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:ssn",
    required: true,
    paramName: "RegularExpression",
    paramValue:
      "^[0-9]{1}[0-9]{2}-[0-9]{2}-[0-9]{4}$|^[0-9]{9}$|| The value for SSN is not in the correct format. It should be a valid Social Security Number or 'UNKNOWN'. You can enter the Social Security Number with or without the dashes. For example, you could enter either '123456789' or '123-45-6789'.",
  },
  // {
  //   paramContext: "bio:daytimePhone",
  //   paramName: "RegularExpression",
  //   paramValue:
  //     "^[0-9]{1}[0-9]{2}-[0-9]{3}-[0-9]{4}$||Phone numbers can only contain numbers and dashes must be in the format '###-###-####'.",
  // },
  {
    paramContext: "ArrestReportsExtra:dnaRequired",
    paramName: "RegularExpression",
    paramValue: "^.$|| Only single character are accepted",
  },
];

const clientParams = [
  {
    paramContext: "bio:lName",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:fName",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:race",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:sex",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "bio:ssn",
    // required: true,
    paramName: "RegularExpression",
    paramValue:
      "^[0-9]{1}[0-9]{2}-[0-9]{2}-[0-9]{4}$|^[0-9]{9}$|| The value for SSN is not in the correct format. It should be a valid Social Security Number or 'UNKNOWN'. You can enter the Social Security Number with or without the dashes. For example, you could enter either '123456789' or '123-45-6789'.",
  },
  {
    paramContext: "bio:dob",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "ArrestReports:agency",
    paramName: "required",
    paramValue: true,
  },

  {
    paramContext: "ArrestReports:arrestCity",
    paramName: "required",
    paramValue: true,
  },

  {
    paramContext: "ArrestReports:arrestDateTime",
    paramName: "required",
    paramValue: true,
  },
  {
    paramContext: "Bio:agency",
    paramName: "required",
    paramValue: true,
  },
];

// clientParams.push(...clientParams1);

export default clientParams;

export const staticFields = {
  personalInfo: {
    [PERSON?.LOW]: [
      {
        columnName: "lName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Last Name",
        required: true,
      },
      {
        columnName: "fName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "First Name",
        required: true,
      },
      {
        columnName: "mName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Middle Name",
      },
      {
        columnName: "suffix",
        type: "bit",
        tableName: "Bio",
        label: "Suffix",
        isID: false,
        longStringRequired: true,
      },
    ],
    [PERSON?.INMATE]: [
      {
        columnName: "lName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Last Name",
        required: true,
      },
      {
        columnName: "fName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "First Name",
        required: true,
      },
      {
        columnName: "mName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Middle Name",
      },
      {
        columnName: "suffix",
        type: "bit",
        tableName: "Bio",
        label: "Suffix",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "pinNo",
        type: "varchar(30)",
        tableName: "Bio",
        label: "Old CRH#",
      },
      {
        columnName: "enrolleeId",
        type: "varchar(50)",
        tableName: "Bio",
        label: "Enrollee ID",
        disabled: true,
      },
      {
        columnName: "race",
        type: "bit",
        tableName: "Bio",
        label: "Race",
        required: true,
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "sex",
        type: "bit",
        tableName: "Bio",
        label: "Gender",
        required: true,
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "height",
        type: "int",
        tableName: "Bio",
        label: "Height",
      },
      {
        columnName: "weight",
        type: "int",
        tableName: "Bio",
        label: "Weight",
      },
      {
        columnName: "hair",
        type: "bit",
        tableName: "Bio",
        label: "Hair Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "eyes",
        type: "bit",
        tableName: "Bio",
        label: "Eye Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "glasses",
        type: "bit",
        tableName: "Bio",
        label: "Glasses",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "hair_Length",
        columnName: "hairLength",
        type: "bit",
        tableName: "Bio",
        label: "Hair Length",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "facial_Hair",
        columnName: "facialHair",
        type: "bit",
        tableName: "Bio",
        label: "Facial Hair",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "complexion",
        type: "bit",
        tableName: "Bio",
        label: "Complexion",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "dlNumber",
        type: "varchar(12)",
        tableName: "Bio",
        label: "Drivers License",
      },
      {
        refListName: "USState",
        columnName: "dlState",
        type: "bit",
        tableName: "Bio",
        label: "DL state",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "dlExpiration",
        type: "date",
        tableName: "Bio",
        label: "Expires",
        disablePastDate: true,
      },
      {
        columnName: "ssn",
        type: "varchar(18)",
        tableName: "Bio",
        label: "SSN",
      },
      {
        columnName: "dob",
        type: "date",
        tableName: "Bio",
        label: "DOB",
        required: true,
      },
      {
        columnName: "ageAtEntry",
        type: "int",
        tableName: "Bio",
        label: "Age",
        disabled: true,
      },
    ],
    [PERSON?.VISITOR]: [
      {
        columnName: "lName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Last Name",
      },
      {
        columnName: "fName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "First Name",
      },
      {
        columnName: "mName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Middle Name",
      },
      {
        columnName: "suffix",
        type: "bit",
        tableName: "Bio",
        label: "Suffix",
        longStringRequired: true,
      },
      {
        columnName: "sex",
        type: "bit",
        tableName: "Bio",
        label: "Gender",
        longStringRequired: true,
      },
      {
        columnName: "dob",
        type: "date",
        tableName: "Bio",
        label: "DOB",
      },
    ],
    [PERSON?.BOOKINGS]: [
      {
        columnName: "lName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Last Name",
        required: true,
      },
      {
        columnName: "fName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "First Name",
        required: true,
      },
      {
        columnName: "mName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Middle Name",
      },
      {
        columnName: "suffix",
        type: "bit",
        tableName: "Bio",
        label: "Suffix",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "pinNo",
        type: "varchar(30)",
        tableName: "Bio",
        label: "Old CRH#",
      },
      {
        columnName: "questionedIdentity",
        type: "checkbox",
        tableName: "Bio",
        label: "Questioned Identity",
      },
      {
        columnName: "enrolleeId",
        type: "varchar(50)",
        tableName: "Bio",
        label: "Enrollee ID",
        disabled: true,
      },
      {
        columnName: "race",
        type: "bit",
        tableName: "Bio",
        label: "Race",
        required: true,
        isID: false,
        // longStringRequired: true,
      },
      {
        refListName: "gender",
        columnName: "sex",
        type: "bit",
        tableName: "Bio",
        label: "Gender",
        required: true,
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "height",
        type: "int",
        tableName: "Bio",
        label: "Height",
      },
      {
        columnName: "weight",
        type: "int",
        tableName: "Bio",
        label: "Weight",
      },
      {
        columnName: "hair",
        type: "bit",
        tableName: "Bio",
        label: "Hair Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "eyes",
        type: "bit",
        tableName: "Bio",
        label: "Eye Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "glasses",
        type: "bit",
        tableName: "Bio",
        label: "Glasses",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "hair_Length",
        columnName: "hairLength",
        type: "bit",
        tableName: "Bio",
        label: "Hair Length",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "facial_Hair",
        columnName: "facialHair",
        type: "bit",
        tableName: "Bio",
        label: "Facial Hair",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "complexion",
        type: "bit",
        tableName: "Bio",
        label: "Complexion",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "ethnicity",
        type: "bit",
        tableName: "Bio",
        label: "Ethnicity",
        longStringRequired: true,
      },
      {
        columnName: "build",
        type: "bit",
        tableName: "Bio",
        label: "Build",
        longStringRequired: true,
      },
      {
        columnName: "skin",
        type: "bit",
        tableName: "Bio",
        label: "Skin",
        longStringRequired: true,
      },
      {
        columnName: "teeth",
        type: "bit",
        tableName: "Bio",
        label: "Teeth",
        longStringRequired: true,
      },
      {
        refListName: "Hair_Style",
        columnName: "hairStyle",
        type: "bit",
        tableName: "Bio",
        label: "Hair Style",
        longStringRequired: true,
      },
      {
        columnName: "daytimePhone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Work Phone",
      },
      {
        columnName: "phone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Home Phone",
      },
      {
        columnName: "cellPhone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Cell Phone",
      },
      {
        columnName: "dlNumber",
        type: "varchar(12)",
        tableName: "Bio",
        label: "Drivers License",
      },
      {
        refListName: "USState",
        columnName: "dlState",
        type: "bit",
        tableName: "Bio",
        label: "DL state",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "dlExpiration",
        type: "date",
        tableName: "Bio",
        label: "Expires",
        disablePastDate: true,
      },
      {
        columnName: "ssn",
        type: "varchar(18)",
        tableName: "Bio",
        label: "SSN",
      },
      {
        columnName: "dob",
        type: "date",
        tableName: "Bio",
        label: "DOB",
        required: true,
      },
      {
        columnName: "ageAtEntry",
        type: "int",
        tableName: "Bio",
        label: "Age",
        disabled: true,
      },
    ],
    [PERSON?.STAFF]: [
      {
        columnName: "lName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Last Name",
        required: true,
      },
      {
        columnName: "fName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "First Name",
        required: true,
      },
      {
        columnName: "mName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Middle Name",
      },
      {
        columnName: "suffix",
        type: "bit",
        tableName: "Bio",
        label: "Suffix",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "aliases",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Aliases",
      },
      {
        columnName: "title",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Title",
      },
      {
        columnName: "ethnicity",
        type: "bit",
        tableName: "Bio",
        label: "Ethnicity",
        longStringRequired: true,
      },
      {
        columnName: "race",
        type: "bit",
        tableName: "Bio",
        label: "Race",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "sex",
        type: "bit",
        tableName: "Bio",
        label: "Gender",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "height",
        type: "int",
        tableName: "Bio",
        label: "Height",
      },
      {
        columnName: "weight",
        type: "int",
        tableName: "Bio",
        label: "Weight",
      },
      {
        columnName: "hair",
        type: "bit",
        tableName: "Bio",
        label: "Hair Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "eyes",
        type: "bit",
        tableName: "Bio",
        label: "Eye Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "glasses",
        type: "bit",
        tableName: "Bio",
        label: "Glasses",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "hair_Length",
        columnName: "hairLength",
        type: "bit",
        tableName: "Bio",
        label: "Hair Length",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "dob",
        type: "date",
        tableName: "Bio",
        label: "DOB",
      },
      {
        columnName: "dlNumber",
        type: "varchar(12)",
        tableName: "Bio",
        label: "Drivers License",
      },
      {
        refListName: "USState",
        columnName: "dlState",
        type: "bit",
        tableName: "Bio",
        label: "DL state",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "dlExpiration",
        type: "date",
        tableName: "Bio",
        label: "Expires",
        disablePastDate: true,
      },
      {
        columnName: "ssn",
        type: "varchar(18)",
        tableName: "Bio",
        label: "SSN",
      },
      {
        columnName: "daytimePhone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Work Phone",
      },
      {
        columnName: "phone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Home Phone",
      },
    ],
    [PERSON?.VISITOR_LOG]: [
      {
        columnName: "lName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Last Name",
        required: true,
      },
      {
        columnName: "fName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "First Name",
        required: true,
      },
      {
        columnName: "mName",
        type: "varchar(10)",
        tableName: "Bio",
        label: "Middle Name",
      },
      {
        columnName: "suffix",
        type: "bit",
        tableName: "Bio",
        label: "Suffix",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "pinNo",
        type: "varchar(30)",
        tableName: "Bio",
        label: "Old CRH#",
      },
      {
        columnName: "questionedIdentity",
        type: "checkbox",
        tableName: "Bio",
        label: "Questioned Identity",
      },
      {
        columnName: "enrolleeID",
        type: "varchar(50)",
        tableName: "Bio",
        label: "Enrollee ID",
        disabled: true,
      },
      {
        columnName: "race",
        type: "bit",
        tableName: "Bio",
        label: "Race",
        isID: false,
        // longStringRequired: true,
      },
      {
        refListName: "gender",
        columnName: "sex",
        type: "bit",
        tableName: "Bio",
        label: "Gender",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "height",
        type: "int",
        tableName: "Bio",
        label: "Height",
      },
      {
        columnName: "weight",
        type: "int",
        tableName: "Bio",
        label: "Weight",
      },
      {
        columnName: "hair",
        type: "bit",
        tableName: "Bio",
        label: "Hair Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "eyes",
        type: "bit",
        tableName: "Bio",
        label: "Eye Color",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "glasses",
        type: "bit",
        tableName: "Bio",
        label: "Glasses",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "hair_Length",
        columnName: "hairLength",
        type: "bit",
        tableName: "Bio",
        label: "Hair Length",
        isID: false,
        longStringRequired: true,
      },
      {
        refListName: "facial_Hair",
        columnName: "facialHair",
        type: "bit",
        tableName: "Bio",
        label: "Facial Hair",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "complexion",
        type: "bit",
        tableName: "Bio",
        label: "Complexion",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "ethnicity",
        type: "bit",
        tableName: "Bio",
        label: "Ethnicity",
        longStringRequired: true,
      },
      {
        columnName: "build",
        type: "bit",
        tableName: "Bio",
        label: "Build",
        longStringRequired: true,
      },
      {
        columnName: "skin",
        type: "bit",
        tableName: "Bio",
        label: "Skin",
        longStringRequired: true,
      },
      {
        columnName: "teeth",
        type: "bit",
        tableName: "Bio",
        label: "Teeth",
        longStringRequired: true,
      },
      {
        refListName: "Hair_Style",
        columnName: "hairStyle",
        type: "bit",
        tableName: "Bio",
        label: "Hair Style",
        longStringRequired: true,
      },
      {
        columnName: "daytimePhone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Work Phone",
      },
      {
        columnName: "phone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Home Phone",
      },
      {
        columnName: "cellPhone",
        type: "varchar(20)",
        tableName: "Bio",
        label: "Cell Phone",
      },
      {
        columnName: "dlNumber",
        type: "varchar(12)",
        tableName: "Bio",
        label: "Drivers License",
      },
      {
        refListName: "USState",
        columnName: "dlState",
        type: "bit",
        tableName: "Bio",
        label: "DL state",
        isID: false,
        longStringRequired: true,
      },
      {
        columnName: "dlExpiration",
        type: "date",
        tableName: "Bio",
        label: "Expires",
        disablePastDate: true,
      },
      {
        columnName: "ssn",
        type: "varchar(18)",
        tableName: "Bio",
        label: "SSN",
      },
      {
        columnName: "dob",
        type: "date",
        tableName: "Bio",
        label: "DOB",
      },
      {
        columnName: "ageAtEntry",
        type: "int",
        tableName: "Bio",
        label: "Age",
        disabled: true,
      },
    ],
  },
  arrest_book_info: {
    [PERSON?.INMATE]: [
      {
        refListName: "Controlling_Agency",
        columnName: "agency",
        type: "bit",
        tableName: "ArrestReports",
        label: "Arresting ORI",
        isID: false,
        longStringRequired: true,
        showSearch: true,
      },
      {
        refListName: "",
        columnName: "bookingOfficer",
        type: "varchar(20)",
        tableName: "ArrestReports",
        label: "Arresting Officer",
        isID: false,
      },
      {
        refListName: "",
        columnName: "officer",
        type: "bit",
        tableName: "ArrestReports",
        label: "Booking Officer",
        isID: false,
        isStaff: true,
      },
      {
        refListName: "",
        columnName: "incarcerationDateTime",
        type: "datetime",
        tableName: "ArrestReports",
        label: "Incarceration Date & Time",
        isID: false,
      },
      {
        refListName: "Inmate_Type",
        columnName: "inmateTypeId",
        type: "bit",
        tableName: "ArrestReports",
        label: "Inmate Type",
        isID: true,
      },
      {
        refListName: "",
        columnName: "controllingAgencyCaseNumber",
        type: "varchar(20)",
        tableName: "ArrestReports",
        label: "Controlling Agency Number",
        isID: false,
        // disabled: true,
      },
      {
        refListName: "Controlling_Agency",
        columnName: "controllingAgency_OriId",
        type: "bit",
        tableName: "ArrestReports",
        label: "Controlling Agency",
        isID: false,
        longStringRequired: true,
        showSearch: true,
      },
    ],
    [PERSON?.BOOKINGS]: [
      {
        refListName: "Controlling_Agency",
        columnName: "agency",
        type: "bit",
        tableName: "ArrestReports",
        label: "Arresting ORI",
        isID: false,
        longStringRequired: true,
        showSearch: true,
      },
      {
        refListName: "",
        columnName: "bookingOfficer",
        type: "varchar(20)",
        tableName: "ArrestReports",
        label: "Arresting Officer",
        isID: false,
      },
      {
        refListName: "",
        columnName: "arrestLocation",
        type: "varchar(20)",
        tableName: "ArrestReports",
        label: "Arrest Location",
        isID: false,
      },
      {
        refListName: "Arrest_City",
        columnName: "arrestCity",
        type: "bit",
        tableName: "ArrestReports",
        label: "Arrest City",
        isID: false,
        showSearch: true,
      },
      {
        refListName: "",
        columnName: "arrestDateTime",
        type: "datetime",
        tableName: "ArrestReports",
        label: "Arrest Date & Time",
        canSelectFutureDate: true,
        isID: false,
      },
      {
        refListName: "Towing_Company",
        columnName: "towingCompany",
        type: "bit",
        tableName: "ArrestReports",
        label: "Towing Company",
        isID: false,
      },
      {
        refListName: "",
        columnName: "intakeWarCheckDate",
        type: "date",
        tableName: "ArrestReports",
        label: "Intake War Check Date",
        isID: false,
      },
    ],
  },
  organizationalRank: [
    {
      columnName: "badge",
      type: "varchar(10)",
      tableName: "Staff",
      label: "Badge Number",
    },
    {
      columnName: "postNumber",
      type: "varchar(10)",
      tableName: "Staff",
      label: "POST #",
      maxLength: 5,
    },
    {
      refListName: "Shift",
      columnName: ["organization", 0, "shift"],
      type: "bit",
      tableName: "Staff",
      label: "Shift",
    },
    {
      columnName: ["organization", 0, "station"],
      type: "varchar(50)",
      tableName: "Bio",
      label: "Station",
    },
    {
      columnName: ["organization", 0, "department"],
      type: "varchar(50)",
      tableName: "Bio",
      label: "Department",
    },
    {
      columnName: ["organization", 0, "division"],
      type: "varchar(50)",
      tableName: "Bio",
      label: "Division",
    },
    {
      refListName: "Housing_Agency",
      columnName: ["organization", 0, "agency"],
      type: "bit",
      tableName: "Bio",
      label: "Agency",
      isID: true,
      required: true,
    },
    {
      refListName: "Rank",
      columnName: ["rankHr", 0, "rank"],
      type: "bit",
      tableName: "Bio",
      label: "Rank",
    },
    {
      columnName: ["rankHr", 0, "rankDate"],
      type: "date",
      tableName: "Bio",
      label: "Rank Date",
    },
    {
      refListName: "Rank_Status",
      columnName: ["rankHr", 0, "status"],
      type: "bit",
      tableName: "Bio",
      label: "Status",
    },
    {
      refListName: "Rank_Commission",
      columnName: ["rankHr", 0, "commission"],
      type: "bit",
      tableName: "Bio",
      label: "Commission",
    },
    {
      columnName: ["rankHr", 0, "comment"],
      type: "text",
      tableName: "Bio",
      label: "Comments",
    },
  ],
};

export const CONFIG_STAGES = {
  INITIAL: 0,
  SELECTED: 1,
  DEPLOY: 2,
  STAGE: 3,
  SAVE_CONFIG: 4,
  SEARCHING: 5,
  MAP_VIEW: 6,
  TABLE_VIEW: 7,
};

export const mandatoryFields = {
  ["personal-information"]: [
    "lName",
    "fName",
    "race",
    "sex",
    "ssn",
    "dob",
    "height",
    "weight",
    "hair",
    "eyes",
    "glasses",
    "hairLength",
    "facialHair",
    "complexion",
    "ethnicity",
    "build",
    "hairStyle",
    "pobType",
  ],
  ["arrest-information"]: ["agency", "arrestCity", "arrestDateTime"],
  ["inmate-information"]: ["holdReasonId"],
  ["property-taken-inmate"]: [
    "releasedTo",
    "releasedByStaffId",
    "dateReleased",
  ],
  ["scheduled-booking-information"]: [
    "scheduledReleaseDateTime",
    "scheduledBookingClearanceReasonId",
    "housingAgency",
  ],
  ["organizational"]: ["agencyId"],
};

export const MODULES_LIST = {
  BOOKINGS: "BOOKINGS",
  BOOKING_INTAKE: "Booking_Intake",
  STAFF: "Staff",
  AUDIT_LOG: "audit-log",
  INMATE_MOVEMENT: "Inmate_Movement",
  FACILITY_LOG: "facility-log",
  USERS: "users",
  CHARGE_MAINTENANCE: "charge-maintenance",
  VISITOR_LOG: "visitor-log",
};

export const MODULES_LIST_WITH_ID = {
  MODULE_Dashboard: "Dashboard",
  MODULE_RELEASESQUEUE: "Release Queue",
  Attorney: "Attorney",
  MODULE_CHARGEMAINTENANCE: "Charge Maintenance",
  MODULE_DATAIMPORTER: "Data Importer",
  MODULE_TRAINING: "Training",
  MODULE_DUTY_LOG: "Duty Log",
  MODULE_BATCHTRANSPORT: "Batch Transport",
  MODULE_BOOKINGVIEW: "Bookings View",
  MODULE_TRANSPORT: "Transport",
  MODULE_BATCHINMATEMOVEMENT: "Batch Inmate Movement",
  MODULE_INMATEWATCH: "Inmate Watch",
  MODULE_INTAKEQUEUE: "Intake Queue",
  MODULE_BOOKINGSQUEUE: "Booking Queue",
  MODULE_JAILINCIDENTS: "Jail Incidents",
  MODULE_UCRSUBMISSION: "UCR Submission",
  MODULE_BOOKINGSINTAKE: "Create Booking",
  MODULE_INCIDENTREPORTS: "Incident Reports UCR",
  MODULE_STATISTICS: "Statistics",
  MODULE_COURT: "Court",
  MODULE_BANKRUPTCYDEBTORS: "Bankruptcy Debtors",
  MODULE_VICTIMNOTIFICATION: "Victim Notification",
  MODULE_DETENTIONS: "Detentions",
  MODULE_WORKCREWS: "Work Crews",
  MODULE_STAFFLITE: "Users",
  MODULE_FACILITYLOG: "Facility Log",
  MODULE_IDENTIFICATION: "Child Identification",
  MODULE_INMATEMOVEMENT: "Inmate Movement",
  MODULE_EXPORTDATA: "Export Data",
  MODULE_WEAPONCONFISCATION: "Weapon Confiscation",
  MODULE_WARRANTS: "Warrants",
  MODULE_VISITORLOG: "Visitor Log",
  MODULE_UCR: "UCR",
  MODULE_SECURITY: "Security",
  MODULE_STAFF: "Staff",
  MODULE_SEXOFFENDERS: "Sex Offenders",
  MODULE_PROPERTYROOM: "Property Room",
  MODULE_PERMITS: "Permits",
  MODULE_PAWNEDPROPERTY: "Pawned Property",
  MODULE_NIBRSSUBMISSION: "Incident Report Submission",
  MODULE_NIBRS: "Incident Reports",
  MODULE_LINEUPS: "Lineups",
  MODULE_INVESTIGATORSVIEW: "Investigator's View",
  MODULE_INTELLIGENCE: "Intelligence",
  MODULE_IMPOUNDEDVEHICLES: "Impounded Vehicles",
  MODULE_FIELDINTERVIEWS: "Field Interviews",
  MODULE_EVIDENCEPROPERTY: "Evidence & Property",
  MODULE_CONFIG: "Config",
  MODULE_CIVILPAPERS: "Civil Papers",
  MODULE_CITATIONS: "Citations",
  MODULE_CASEMANAGEMENT: "Case Management",
  MODULE_BOOKINGSUMMARY: "Bookings Summary",
  MODULE_BOOKINGS: "Bookings",
  MODULE_BANKRUPTCY: "Bankruptcy",
  MODULE_AUDITLOG: "Audit Log",
  MODULE_AGENCYPROPERTY: "Agency Property",
  MODULE_ADDRESSBOOK: "Address Book",
  MODULE_ACCIDENTREPORTS: "Accident Reports",
};

export const SUB_MODULES_LIST_WITH_ID = {
  Inmate_Cash_Account: "Inmate Cash Account",
  Inmate_Property: "Inmate Property",
  Inmate_Officer_Reports: "Inmate Officer Reports",
  Arrest_Report: "Arrest Report",
  Inmate_Medical: "Inmate Medical",
};

export const SCHEMA_NAME = {
  ARREST_REPORT: "ArrestReports",
  CHARGES: "Charges",
};

export const SCHEMA_FIELD_NAME = {
  SCHEDULED_BOOKING_CLEARED: "scheduledBookingCleared",
  CHARGE_DESCRIPTION_ID: "chargeDescriptionID",
  CHARGE_LEVEL_ID: "chargeLevelID",
  CHARGE_COUNT: "chargeCount",
  CHARGE_MODIFIER_ID: "chargeModifierID",
  CONTROLLING_AGENCY_ORI_ID: "controllingAgencyORIID",
  CASE_NUMBER: "caseNumber",
  COURT_NUMBER: "courtNumber",
  ORIGINAL_CUSTODY_REASON_ID: "originalCustodyReasonID",
  TICKET_NUMBER: "ticketNumber",
  WARRANT_NUMBER: "warrantNumber",
  COMMENTS: "comments",
};

export const REF_LIST_CONSTANT = {
  Inmate_Movement_Rule_Type: {
    INMATEMOVEMENTTYPE_KEEPSEPARATE: 54020001,
    INMATEMOVEMENTTYPE_OTHER: 54020002,
    INMATEMOVEMENTTYPE_COMMONRULES: 54020003,
  },
  Keep_Separate_Type: {
    KEEPSEPARATETYPE_POPULATION: 54030001,
    KEEPSEPARATETYPE_SPECIFICPERSON: 54030002,
    KEEPSEPARATETYPE_OTHER: 54030003,
    KEEPSEPARATETYPE_JUVENILES: 54030004,
  },
};
